import { Reveal } from "@/lib/motion";
import { CREDENTIALS } from "@/data/site";

// Training & credentials — authentic Intuit badge artwork supplied by the owner, shown unaltered.
export const Credentials = () => (
  <section data-testid="credentials-section" className="bg-cream py-24">
    <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-[12px] uppercase tracking-[0.28em] text-[#8a6b2f] mb-5">Training & credentials</p>
        <h2 className="font-serif text-3xl lg:text-4xl text-navy tracking-tight leading-tight max-w-2xl">
          Continuing training in bookkeeping and QuickBooks
        </h2>
      </Reveal>
      <div className="mt-12 grid sm:grid-cols-3 gap-6">
        {CREDENTIALS.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.08}>
            <figure data-testid={`credential-${c.id}`} className="group h-full bg-cream-ivory border border-[#D9CFB8] p-8 flex flex-col items-center text-center hover:border-[#8a6b2f]/60 motion-safe:hover:-translate-y-1 hover:shadow-[0_18px_40px_-24px_rgba(11,31,59,0.35)] transition-[border-color,transform,box-shadow] duration-300">
              <div className="w-40 h-40 flex items-center justify-center">
                <img src={c.image} alt={`${c.status} badge — ${c.label}`}
                  className="max-w-full max-h-full object-contain motion-safe:group-hover:scale-[1.04] transition-transform duration-500" loading="lazy" />
              </div>
              <figcaption className="mt-6">
                <p className="font-serif text-xl text-navy leading-snug">{c.label}</p>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-[#8a6b2f]">{c.status}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
